import { Box } from '@mui/material';

const borderColor = '#000';

const mainContainerStyle = {
	display: 'flex',
	flexDirection: 'column',
	maxWidth: '100%',
	borderLeft: `1px solid ${borderColor}`,
	borderBottom: `1px solid ${borderColor}`,
	borderRight: `1px solid ${borderColor}`,
	borderRadius: '5px',
	margin: '1em',
};

const childrenContainerStyle = {
	padding: '0 1em 1em 1em',
};

const headerStyle = {
	display: 'flex',
	flexDirection: 'row',
	width: '100% !important',
};

const headerBorderBeforeStyle = {
	borderTop: `1px solid ${borderColor}`,
	width: '1em',
	borderTopLeftRadius: '5px',
};

const headerTitleStyle = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	alignItems: 'center',
	gap: '0.25em',
	width: 'fit-content',
	height: '2em',
	margin: '-1em 0.5em 0em 0.5em',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontSize: '1em',
	fontWeight: 600,
};

const headerBorderAfterStyle = {
	borderTop: `1px solid ${borderColor}`,
	width: '1em',
	flexGrow: 2,
	borderTopRightRadius: '5px',
};

interface LabelContainerProps {
	icon?: React.ComponentType;
	title?: string;
	children: React.ReactNode;
}

export const LabelContainer = ({ icon: Icon, title, children }: LabelContainerProps) => (
	<Box sx={mainContainerStyle}>
		<Box sx={headerStyle}>
			<Box sx={headerBorderBeforeStyle} />
			{(Icon || title) && (
				<Box sx={headerTitleStyle}>
					{Icon && <Icon />}
					{title && <span>{title}</span>}
				</Box>
			)}
			<Box sx={headerBorderAfterStyle} />
		</Box>
		<Box sx={childrenContainerStyle}>{children}</Box>
	</Box>
);
